// import { useRoutes } from './routes/Routes';
import { BrowserRouter as Router } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import SessionManager from './components/SessionManager';
import './lib/helper/string.extensions';
import RTL from './lib/RTL';
import { useRoutes } from './routes/Routes';


function App() {
  return (
      <RTL>
        <Router>
          <SessionManager />
         
          {
            useRoutes()
          }
          <ToastContainer position={'bottom-right'} bodyStyle={{ width: '100%', borderRadius: 0 }}  hideProgressBar />
        </Router>
      </RTL>
  );
}

export default App;
